module.exports = __webpack_public_path__ + "img/model-art-1.9dbde9b.svg";